import { createSlice } from '@reduxjs/toolkit';
import { HomeTextEmptyState, IHomeTextState } from './fetchHomeTextState';
import { fetchDefaultHomeText } from './fetchHomeTextThunk';
import { QueryState } from 'common/enums';

const initialState: IHomeTextState = HomeTextEmptyState;

export const fetchHomeDefaultText = createSlice({
  name: 'fetchHomeText',
  initialState,
  reducers: {
    resetFetchHomeDefaultText: () => {
      return initialState;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(fetchDefaultHomeText.pending, (state) => {
        state.state = QueryState.AWAIT;
      })
      .addCase(fetchDefaultHomeText.fulfilled, (state, action) => {
        state.state = QueryState.READY;
        state.text = action.payload;
      })
      .addCase(fetchDefaultHomeText.rejected, (state, action) => {
        state.state = QueryState.FAIL;
        state.error = action.error.message || 'Something went wrong!';
      });
  }
});

export const { resetFetchHomeDefaultText } = fetchHomeDefaultText.actions;
export default fetchHomeDefaultText.reducer;
